// vee-validate setup for the event-landing-ui app.
// Mirrors resources/js/apps/global-declare-components/plugins/vee-validate.js
// (same rules + messages) so registration forms validate identically to the
// rest of the platform. Loaded from event-landing-ui/index.js.
import { ValidationProvider, ValidationObserver, localize, extend, setInteractionMode } from 'vee-validate'
import { email, required } from 'vee-validate/dist/rules'
import en from 'vee-validate/dist/locale/en.json'
import * as rules from 'vee-validate/dist/rules'

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})

// Validate after a field loses focus (and re-validate on input thereafter),
// instead of the default aggressive mode that flags mismatches mid-typing —
// e.g. "Confirm email" while the user is still typing it.
setInteractionMode('eager')

localize('en', en)

extend('required', {
  ...required,
  message: 'This field is required'
})

extend('email', {
  ...email,
  message: 'The field must be a valid email address'
})

extend('price', {
  validate: value => /^\d+(\.\d+)?$/.test(value),
  message: 'Only numbers and a decimal point are allowed'
})

// `confirmed` (built-in, loaded above) is used by the attendee "Confirm email"
// field via rules="confirmed:@email-<idx>"; override only the message.
extend('confirmed', {
  ...rules.confirmed,
  message: 'The {_field_} does not match'
})

// Confirm-email comparison by literal value instead of cross-field @vid
// resolution (which is brittle with dynamically-rendered schema fields). The
// target value is passed as a param and recomputed reactively.
extend('matches', {
  params: ['other'],
  validate: (value, { other }) => String(value ?? '') === String(other ?? ''),
  message: 'The {_field_} does not match'
})

Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
